/**
 *
 * FaqItem
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import Card from 'components/Card';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import ClassNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import { makeSelectAuth } from 'containers/Auth/selectors';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import Badge from 'components/Badge';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Mixpanel from 'utils/mixpanelService';
import ArrowRight from './images/arrow-right.svg';

const styles = theme => ({
  link: {
    textDecoration: 'none',
    position: 'relative',
  },
  content: {
    display: 'flex',
    padding: '0 15px',
  },
  topic: {
    marginTop: 20,
    display: '-webkit-box',
    '-webkit-line-clamp': '1',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 20 /* Fallback for non-webkit */,
    marginBottom: 5,
  },
  topicLink: {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  title: {
    marginBottom: 3,
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 40 /* Fallback for non-webkit */,
  },
  divider: {
    width: 30,
    height: 3,
    margin: '15px 0',
    background: '#C7DEE8',
  },
  answerHeader: {
    ...theme.typography.pSmallBold,
  },
  answer: {
    marginBottom: 5,
    display: '-webkit-box',
    '-webkit-line-clamp': '5',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 110 /* Fallback for non-webkit */,
  },
  richTextAnswer: {
    marginBottom: 5,
    display: '-webkit-box',
    '-webkit-line-clamp': '5',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 110 /* Fallback for non-webkit */,
    '& ul': {
      margin: 0,
    },
    '& span': {
      margin: 0,
    },
  },
  btnLink: {
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    width: 116,
    background: '#fff',
    height: 34,
    position: 'relative',
    fontSize: 15,
    color: theme.palette.text.secondary,
    marginTop: 15,
    borderRadius: 2,
    textDecoration: 'none',
  },
  arrowIcon: {
    position: 'absolute',
    right: 10,
    marginTop: 1,
  },
});

class FaqItem extends React.PureComponent {
  redirect = () => {
    const {
      data: { article },
      type = 'faq',
      location,
    } = this.props;
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Resource Card - Clicked', {
      name: article,
      type,
      page: finalPageName,
      path: location.pathname.split('/')[1],
      slug: location.pathname.split('/')[2],
    });
  };

  redirectTopic = (e, title) => {
    e.stopPropagation();

    const { location } = this.props;
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Resource Card - Clicked', {
      name: title,
      type: 'topic-faq-card',
      page: finalPageName,
      path: location.pathname.split('/')[1],
      slug: location.pathname.split('/')[2],
    });
  };

  render() {
    const {
      classes,
      data,
      data: { article = '', allTopics = [], slug, content = '', topics = [] },
      type = 'faq',
      route = '/faqs',
      background,
      height,
    } = this.props;
    if (_isEmpty(data)) return null;
    const stringContent = typeof content === 'string';
    const finalTopics =
      _isEmpty(allTopics) && !_isEmpty(topics)
        ? topics.map(
            ({ fields }) =>
              !_isEmpty(_get(fields, 'title')) && {
                title: fields.title,
                slug: fields.slug,
              },
          )
        : allTopics;
    const relatedTopics = !_isEmpty(finalTopics)
      ? finalTopics.map((topic, index) => {
          const topicRoute = `/topics/${topic.slug}`;

          return (
            <Link
              key={topic.slug}
              to={topicRoute}
              className={classes.topicLink}
              onClick={e => this.redirectTopic(e, topic.title)}
            >
              {index === 0 ? topic.title : `, ${topic.title}`}
            </Link>
          );
        })
      : '';

    // react-router issue
    const relativePath = this.props.match.url.split('/')[1];
    const finalRoute = relativePath === route ? `${slug}` : `${route}/${slug}`;

    return (
      <Link to={finalRoute} className={classes.link} onClick={this.redirect}>
        <Card
          height={height}
          background={background}
          borderColor="transparent"
          padding={0}
        >
          <div className={ClassNames(classes.desktopWrapper)}>
            <Grid container justify="flex-start">
              <Grid item xs={12} className={classes.badgeWrapper}>
                <Badge type={type} />
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <Typography
                  variant="overline"
                  color="textSecondary"
                  align="left"
                  className={classes.topic}
                >
                  {relatedTopics}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <Typography
                  variant="h6"
                  color="textPrimary"
                  align="left"
                  className={classes.title}
                >
                  {article}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <span className={classes.divider} />
              </Grid>
              {/* <Grid item xs={12} className={classes.content}>
                <Typography align="left" className={classes.answerHeader}>
                  Answer:
                </Typography>
              </Grid> */}
              <Grid item xs={12} className={classes.content}>
                {stringContent ? (
                  <Typography
                    variant="overline"
                    color="textPrimary"
                    align="left"
                    className={classes.answer}
                  >
                    {content}
                  </Typography>
                ) : (
                  <div className={classes.richTextAnswer}>
                    <RichTextReactRenderer
                      data={content}
                      type="name"
                      name={article}
                      contentType="faq"
                    />
                  </div>
                )}
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <Link
                  to={finalRoute}
                  className={classes.btnLink}
                  onClick={this.redirect}
                >
                  Read more
                  <img
                    src={ArrowRight}
                    alt="Read more"
                    className={classes.arrowIcon}
                  />
                </Link>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Link>
    );
  }
}
FaqItem.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  type: PropTypes.string,
  route: PropTypes.string,
  height: PropTypes.number,
  location: PropTypes.object,
  background: PropTypes.string,
  match: PropTypes.object,
};

FaqItem.defaultProps = {
  height: 348,
  background: '#E8F1F5',
};

const mapStateToProps = createStructuredSelector({
  auth: makeSelectAuth(),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withRouter,
  withConnect,
  withStyles(styles),
)(FaqItem);
